import { isValidImageUrl } from "./resolveImageUrl";

const HEX_PATTERN = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

// Builds the inline style for a color swatch from API swatch data:
// swatchImage first, then swatchHex. Returns null when neither is usable so
// the caller can apply its own fallback color.
export function getSwatchStyle(option) {
  const image = String(option?.swatchImage ?? "").trim();
  if (image && isValidImageUrl(image)) {
    return {
      backgroundImage: `url("${image.replace(/"/g, "%22")}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    };
  }

  const hex = String(option?.swatchHex ?? "").trim();
  if (HEX_PATTERN.test(hex)) {
    return { backgroundColor: hex };
  }

  return null;
}
